// Load only the page the user opens; keep routing metadata synchronous.
export const LEGACY_PAGES = [
  {id:'overview',title:'Overview',load:async()=>{
    const [markup,logic]=await Promise.all([import('./overview.markup.js'),import('./overview.logic.js')]);
    return {...markup,mount:logic.mountOverview};
  }},
  {id:'paid-media',title:'Paid Media',load:async()=>{
    const [markup,logic]=await Promise.all([import('./paidMedia.markup.js'),import('./paidMedia.logic.js')]);
    return {...markup,mount:logic.mountPaidMedia};
  }},
  {id:'crm',title:'CRM',load:async()=>{
    const [markup,logic]=await Promise.all([import('./crm.markup.js'),import('./crm.logic.js')]);
    return {...markup,mount:logic.mountCrm};
  }},
  {id:'wa-acquisition',title:'Web - Acquisition',load:async()=>{
    const [markup,logic]=await Promise.all([import('./waAcquisition.markup.js'),import('./waAcquisition.logic.js')]);
    return {...markup,mount:logic.mountWaAcquisition};
  }},
  {id:'wa-audience',title:'Web - Audience',load:async()=>{
    const [markup,logic]=await Promise.all([import('./waAudience.markup.js'),import('./waAudience.logic.js')]);
    return {...markup,mount:logic.mountWaAudience};
  }},
  {id:'wa-behavior',title:'Web - Behavior',load:async()=>{
    const [markup,logic]=await Promise.all([import('./waBehavior.markup.js'),import('./waBehavior.logic.js')]);
    return {...markup,mount:logic.mountWaBehavior};
  }},
  {id:'wa-monetization',title:'Web - Monetization',load:async()=>{
    const [markup,logic]=await Promise.all([import('./waMonetization.markup.js'),import('./waMonetization.logic.js')]);
    return {...markup,mount:logic.mountWaMonetization};
  }},
  {id:'social-organic',title:'Social Organic',load:async()=>{
    const [markup,logic]=await Promise.all([import('./socialOrganic.markup.js'),import('./socialOrganic.logic.js')]);
    return {...markup,mount:logic.mountSocialOrganic};
  }},
  {id:'social-listening',title:'Social Listening',load:async()=>{
    const [markup,logic]=await Promise.all([import('./socialListening.markup.js'),import('./socialListening.logic.js')]);
    return {...markup,mount:logic.mountSocialListening};
  }},
];
export const DEFAULT_PAGE = "overview";
